import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { register as registerSW } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// PWA — register service worker (production only)
registerSW();
